const css = `
@tailwind utilities;
`;

export default css;
